export default __webpack_public_path__ + "static/global-iso-hand-c8b78e35523c85caaca0f243d99cd128.svg";